import React, { useContext, useState } from "react";
import { IconButton, Box, AppBar, Toolbar, Button, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { removeCookies } from "../../services/Cookies";
import { logout, setLoggedIn } from "../../store/Slices/userSlice";
import { useDispatch } from "react-redux";
import { ThemeContext } from "../../context/ThemeContext";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import OneClickBtn from '../../assets/oneClick.png'
import BtnTrade from '../../assets/newOrder.png'
import UserMenu from "../menu/UserMenu";
import { useTranslation } from 'react-i18next';
import TradingAccounts from '../../pages/auth/Login'
import '../../App.scss'
import { IoIosMenu } from "react-icons/io";
import { FiFileText } from "react-icons/fi";
import { MdAdsClick } from "react-icons/md";
import { setIsOneClick } from "../../store/Slices/watchList";

const Header = ({ containerRef, openOneClickModal, closeOneClickModal, toggleSymbolPanel, isSymbolPanelVisible, handleOpenOneTradeModal, currentSymbolId, handleOpenNewDashboard }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { userDetail } = useSelector((state) => state.user);
  const client = userDetail || {};
  const { darkMode } = useContext(ThemeContext)
  const { accountId, accountData } = useSelector(state => state.accountSummary)
  const isOneClick = useSelector(state => state.watchlist?.isOneclick)
  const [isOneClickOpen, setIsOneClickOpen] = useState(false);
  const { t } = useTranslation();
  const [isTradingAccountsOpen, setIsTradingAccountsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  // const [oneClick, setOneClick] = useState(true);


  const handleOpenTradingAccounts = (tabName) => {
    setActiveTab(tabName);
    setIsTradingAccountsOpen(true);
  };

  const handleCloseTradingAccounts = () => {
    setIsTradingAccountsOpen(false);
  };

  const handleMenuClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    removeCookies("username", { path: "/" });
    removeCookies("token", { path: "/" });
    removeCookies("clientId", { path: "/" });
    removeCookies('gmtOffset', { path: '/' })
    localStorage.removeItem('visibleColumns')
    localStorage.setItem("accountID", "");

    dispatch(setLoggedIn(false));
    dispatch(logout());
    window.location.href = "/";
  };

  const handleFullscreenToggle = () => {
    if (!isFullscreen) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
      setIsFullscreen(false);
    }
  }

  const toggleOneClickModal = () => {
    // if (isOneClickOpen) {
    //   closeOneClickModal();
    // } else {
    //   openOneClickModal();
    // }
    // setIsOneClickOpen((prev) => !prev);
    const agreementKey = `oneClickTradingAgreement_${client.id}`;
    const agreement = JSON.parse(localStorage.getItem(agreementKey));
    if (!agreement?.agreed && !isOneClickOpen) {
      openOneClickModal(); 
    } else {
      setIsOneClickOpen((prev) => !prev);
      dispatch(setIsOneClick(!isOneClick));
    }
  };

  const imageSrc = darkMode ? '/Vfx-logo_white.png' : '/Vfx logo.png';
  return (
    <>
      <AppBar elevation={0} sx={{ backgroundColor: darkMode ? "var(--background-color)" : 'var(--white)', zIndex: 1250, border: 'none', borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} >
        <Toolbar sx={{ alignItems: "center" }}>
          <Box onClick={handleMenuClick} size="small" sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: '0' }}>
            <IconButton style={{ marginRight: '8px', marginLeft: '10px', }}>
              <IoIosMenu />
            </IconButton>
          </Box>
          <div className="ms-2 flex">
            <a href="https://hybridsolutions.com/vertex-trading-platform/" target="_blank"><img src={imageSrc} alt="logo" style={{ height: '22px' }} /></a>
          </div>
          <Box display='flex' gap={1} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, px: 1 }}>
            <Tooltip title={isOneClickOpen ? t("hideOneClickModal") : t("showOneClickModal")}>
              <IconButton onClick={toggleOneClickModal}>
                <img src={OneClickBtn} alt="" width={20} style={{ filter: isOneClickOpen ? 'grayscale(100%)' : 'none', opacity: isOneClickOpen ? 0.5 : 1, height: '13px' }} />
              </IconButton>
            </Tooltip>

            <Tooltip title={t('newOrder')}>
              <Button onClick={() => handleOpenOneTradeModal(currentSymbolId)} sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)', fontSize: '0.8rem', display: 'flex', alignItems: 'center', textTransform: 'none' }}>
                <img src={BtnTrade} alt="BtnTrade" width={18} style={{ marginRight: '5px' }} />
                {t('newOrder')}
              </Button>
            </Tooltip>
          </Box>
          <Box display='flex' gap={1} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, px: 1 }}>
            <Tooltip title={isSymbolPanelVisible ? t('hideMarketWatch') : t('showMarketWatch')}>
              <IconButton onClick={toggleSymbolPanel}>
                <FiFileText style={{ fontSize: 18, color: isSymbolPanelVisible ? 'var(--primary)' : 'inherit' }} />
              </IconButton>
            </Tooltip>

          </Box>

          <Box flexGrow={1} />
          <Tooltip title={!isOneClick ? t('defaultView') : t('oneTrading')}>
            <IconButton onClick={toggleOneClickModal}
            ><MdAdsClick style={{ fontSize: 18, color: !isOneClick ? 'var(--primary)' : 'inherit' }} /></IconButton>
          </Tooltip>

          <Tooltip title={isFullscreen ? t('exitFullscreen') : t('enterFullscreen')}>
            <IconButton onClick={handleFullscreenToggle} >
              {isFullscreen ? <FullscreenExitIcon sx={{ fontSize: 20 }} /> : <FullscreenIcon sx={{ fontSize: 20 }} />}
            </IconButton>
          </Tooltip>


          <UserMenu onOpenTradingAccounts={handleOpenTradingAccounts} anchorEl={anchorEl} darkMode={darkMode} id={accountId} client={client} handleClose={handleClose} handleLogout={handleLogout} accountData={accountData} />
        </Toolbar>
      </AppBar>
      {isTradingAccountsOpen && (
        <div style={{ position: 'absolute', top: 80, left: "25%" }}>
          <TradingAccounts onClose={handleCloseTradingAccounts} activeTab={activeTab} />
        </div>
      )}

    </>
  );
};

export default Header;
